module.exports = __webpack_public_path__ + "img/automation.a46513a9.jpg";